import * as React from 'react';
import axios from 'axios';
import { OverlayWrapper, TableWrapper } from './styles';
import { Map, GoogleApiWrapper, InfoWindow, IMarkerProps, Polyline, IMapProps } from 'google-maps-react';
import { IMarker, IGeoCodeResponse, IPolyline, IInProcessSwap } from './models';
import CustomMarker from './custom-marker';

interface IProps {
    swapList: IInProcessSwap[],
    single: boolean,
    display: IMarker[],
    flightLines: IPolyline[],
    center: {
        lat: number,
        lng: number
    },
    zoom: number,
    google: any
}

interface IState {
    active: {
        show: boolean,
        marker: any,
        item: IMarker,
    },
    waypoint: {
        show: boolean,
        marker: any,
        item: IMarker,
        geocodeData: string
    },
}

class NkrMap extends React.Component<IProps, IState> {
    readonly state: IState = {
        active: {
            show: false,
            marker: {},
            item: null,
        },
        waypoint: {
            show: false,
            marker: {},
            item: null,
            geocodeData: ''
        },
    }

    google: any;
    map: any;

    onGoogleMapApiLoaded = (google) => {
        this.google = google;
    }

    handleMapReady = (mapProps, map) => {
        this.google = mapProps.google;
        this.map = map;
    }

    handleMapClick = (mapProps?: IMapProps, map?: google.maps.Map, event?) => {
        this.setState({
            active: {
                show: false,
                marker: {},
                item: null,
            },
            waypoint: {
                show: false,
                marker: {},
                item: null,
                geocodeData: ''
            }
        });
    }

    handleMapEvent = (mapProps?: IMapProps, map?: google.maps.Map, event?) => {
        // console.log(map.getZoom());
        // console.log({ lat: map.getCenter().lat(), lng: map.getCenter().lng() });
    }

    handleZoomChange = (mapProps?: IMapProps, map?: google.maps.Map, event?) => {
        // console.log(map.getZoom());
    }

    handleMarkerClick = (item: IMarker, props, marker, e) => {
        this.setState({
            active: {
                show: true,
                marker: marker,
                item,
            },
            waypoint: {
                show: false,
                marker: {},
                item: null,
                geocodeData: ''
            }
        });
    }

    handleWaypointClick = (item: IMarker, props, marker, e) => {
        axios.get('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + item.lat + ',' + item.lng + '&result_type=street_address|route|intersection|airport&key=' + __GOOGLE_MAPS_API_KEY__).then((response: IGeoCodeResponse) => {
            let route = response.data.results.filter(x => x.types.filter(t => t == 'route' || t == 'airport').length > 0);

            this.setState({
                active: {
                    show: false,
                    marker: {},
                    item: null,
                },
                waypoint: {
                    show: true,
                    marker,
                    item,
                    geocodeData: route.length > 0 ? route[0].formatted_address : ''
                }
            });
        });
    }

    render = () => {
        const swapList = this.props.swapList;
        const singleSwap = this.props.single && swapList.length > 0 ? swapList[0] : null;

        const styles = {
            width: '100%',
            height: this.props.single ? '78vh' : '80vh',
            position: 'relative'
        };

        const containerStyles = {
            position: 'relative',
            width: '100%',
            height: '100%'
        }

        return (
            <OverlayWrapper>
                <Map
                    google={this.props.google}
                    zoom={this.props.zoom}
                    style={styles}
                    containerStyle={containerStyles}
                    initialCenter={this.props.center}
                    onReady={this.handleMapReady}
                    onClick={this.handleMapClick}
                    onDblclick={this.handleMapEvent}
                    onCenterChanged={this.handleMapEvent}
                    onZoomChanged={this.handleZoomChange}
                >
                    {this.props.display.map((item, index) => {
                        if (item.isWaypoint == false) {
                            return (
                                <CustomMarker
                                    key={'m-' + index}
                                    // item={item}
                                    position={{ lat: item.lat, lng: item.lng }}
                                    icon={{
                                        url: item.isDonorCenter ? '/images/d.svg' : '/images/r.svg',
                                        scaledSize: new google.maps.Size(32, 32)
                                    }}
                                    // animation={2}
                                    onClick={(props?: IMarkerProps, marker?: google.maps.Marker, event?) => this.handleMarkerClick(item, props, marker, event)}
                                />
                            );
                        }

                        if (item.isWaypoint == true) {
                            return (
                                <CustomMarker
                                    key={'wm-' + index}
                                    position={{ lat: item.lat, lng: item.lng }}
                                    icon={{
                                        url: item.isLast == false ? '/images/dot.png' : '/images/luggage.svg',
                                        scaledSize: item.isLast == false ? new google.maps.Size(16, 16) : new google.maps.Size(32, 32)
                                    }}
                                    onClick={(props?: IMarkerProps, marker?: google.maps.Marker, event?) => this.handleWaypointClick(item, props, marker, event)}
                                />
                            );
                        }
                    })}

                    {this.props.flightLines.map((line, index) =>
                        <Polyline
                            key={'pl-' + index}
                            path={line.path}
                            strokeColor={line.strokeColor}
                            strokeOpacity={line.strokeOpacity}
                            strokeWeight={line.strokeWeight}
                            onClick={(e: any) => console.log(e)}
                        />
                    )}

                    <InfoWindow
                        google={this.google}
                        map={this.map}
                        marker={this.state.active.marker}
                        visible={this.state.active.show}>
                        <>
                            {this.state.active.item != null && (
                                <TableWrapper bordered condensed style={{ marginBottom: 0 }}>
                                    <tbody>
                                        <tr>
                                            <td>Swap:</td>
                                            <td>{this.state.active.item.data.chainId}/{this.state.active.item.data.clusterNumber}/{this.state.active.item.data.positionNumber}</td>
                                        </tr>

                                        {this.state.active.item.data.rdnCenterId == 0 ?
                                            <tr>
                                                <td style={{ fontWeight: this.state.active.item.isDonorCenter ? 700 : 400 }}>Donor Center:</td>
                                                <td style={{ fontWeight: this.state.active.item.isDonorCenter ? 700 : 400 }}>{this.state.active.item.data.donorCenter}</td>
                                            </tr>
                                            :
                                            <>
                                                <tr style={{ backgroundColor: 'yellow' }}>
                                                    <td style={{ fontWeight: this.state.active.item.isDonorCenter ? 700 : 400 }}>Remote Center:</td>
                                                    <td style={{ fontWeight: this.state.active.item.isDonorCenter ? 700 : 400 }}>{this.state.active.item.data.rdnCenterAlias}</td>
                                                </tr>

                                                <tr>
                                                    <td style={{ fontWeight: this.state.active.item.isDonorCenter ? 700 : 400 }}>Managing Center:</td>
                                                    <td style={{ fontWeight: this.state.active.item.isDonorCenter ? 700 : 400 }}>{this.state.active.item.data.donorCenter}</td>
                                                </tr>
                                            </>
                                        }

                                        <tr>
                                            <td style={{ fontWeight: this.state.active.item.isDonorCenter ? 700 : 400 }}>Scheduled Pickup:</td>
                                            <td style={{ fontWeight: this.state.active.item.isDonorCenter ? 700 : 400 }}>{this.state.active.item.data.kidneyPickup}</td>
                                        </tr>

                                        <tr>
                                            <td style={{ fontWeight: !this.state.active.item.isDonorCenter ? 700 : 400 }}>Recipient Center:</td>
                                            <td style={{ fontWeight: !this.state.active.item.isDonorCenter ? 700 : 400 }}>{this.state.active.item.data.recipientCenter}</td>
                                        </tr>

                                        <tr>
                                            <td style={{ fontWeight: !this.state.active.item.isDonorCenter ? 700 : 400 }}>Scheduled Arrival:</td>
                                            <td style={{ fontWeight: !this.state.active.item.isDonorCenter ? 700 : 400 }}>{this.state.active.item.data.kidneyArrival}</td>
                                        </tr>
                                    </tbody>
                                </TableWrapper>
                            )}
                        </>
                    </InfoWindow>

                    <InfoWindow
                        google={this.google}
                        map={this.map}
                        marker={this.state.waypoint.marker}
                        visible={this.state.waypoint.show}>
                        <>
                            {this.state.waypoint.item != null && (
                                <TableWrapper bordered condensed style={{ marginBottom: 0 }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ paddingRight: 5, fontWeight: 700 }}>Date/Time:</td>
                                            <td colSpan={3}>{this.state.waypoint.item.pickupDateTime}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ paddingRight: 5, fontWeight: 700 }}>Latitude:</td>
                                            <td style={{ paddingRight: 5 }}>{this.state.waypoint.item.lat}</td>
                                            <td style={{ paddingRight: 5, fontWeight: 700, textAlign: 'right' }}>Longitude:</td>
                                            <td>{this.state.waypoint.item.lng}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ paddingRight: 5, fontWeight: 700 }}>Location:</td>
                                            <td colSpan={3} style={{ maxWidth: 250 }}>{this.state.waypoint.geocodeData}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ paddingRight: 5, fontWeight: 700 }}>Battery:</td>
                                            <td colSpan={3}>{this.state.waypoint.item.batteryPercentage}%</td>
                                        </tr>
                                    </tbody>
                                </TableWrapper>
                            )}
                        </>
                    </InfoWindow>
                </Map>

                {this.props.single && (
                    <div id='pngdiv'>
                        {singleSwap != null ?
                            <TableWrapper bordered condensed>
                                <tbody>
                                    <tr>
                                        <td>Swap:</td>
                                        <td>{singleSwap.chainId}/{singleSwap.clusterNumber}/{singleSwap.positionNumber}</td>
                                    </tr>
                                    <tr>
                                        <td>Donor Center:</td>
                                        <td>{singleSwap.donorCenter}</td>
                                    </tr>
                                    <tr>
                                        <td>Recipient Center:</td>
                                        <td>{singleSwap.recipientCenter}</td>
                                    </tr>
                                    <tr>
                                        <td>Scheduled Pickup:</td>
                                        <td>{singleSwap.kidneyPickup}</td>
                                    </tr>
                                    <tr>
                                        <td>Scheduled Dropoff:</td>
                                        <td>{singleSwap.kidneyArrival}</td>
                                    </tr>
                                </tbody>
                            </TableWrapper>
                            :
                            <div>Loading swap...</div>
                        }
                    </div>
                )}
            </OverlayWrapper>
        );
    }
}

export default GoogleApiWrapper({
    apiKey: __GOOGLE_MAPS_API_KEY__
})(NkrMap);
